import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'employee-planning',
    description:
      'An application to help plan and manage employee resources within an organization.',
    icon: 'bulb1',
    name: 'Employee Planning',
    scenarioVariables: [],
    sessionVariables: [],
    supportsScenarios: false,
  },
  type: core.quiver.Resource.Type.App,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.App>
